import React, {Component} from 'react';

import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import dayjs from "dayjs";
import { datetimeLocalToString } from '../../../lib/helpers/datetime-helpers';
import coWorkingApi from '../../../lib/co-working/co-working-api';

class AvailibilityCalendar extends Component {

    constructor(props) {
        super(props);

        this.calEl = null;
    }

    setRef(r) {
        this.calEl = r;
    }

    onClickDay(date) {
        const day = dayjs(date).format('YYYY-MM-DD');

        this.props.onDaySelect(day);
    }

    isDayDisabled(date, view) {
        if (dayjs(date).isBefore(dayjs(), 'day')) return true;

        const day = dayjs(date).format('YYYY-MM-DD');

        return this.props.bookings.hasOwnProperty(day) ? !this.props.bookings[day]?.available_for_no_requested_attendees  : false;
    }

    handleViewChange(data) {
        this.getBookings(data.activeStartDate);
    }

    render() {
        return (
            <div>
                <Calendar
                    className={'appointment-cal'}
                    inputRef={this.setRef.bind(this)}
                    tileDisabled={({ date, view }) => this.isDayDisabled(date, view)}
                    onClickDay={this.onClickDay.bind(this)}
                    onActiveStartDateChange={this.props.handleViewChange}
                    formatDay={(local, date) => {
                            return(
                                <div className={'appointment-cal__day'}>
                                    { dayjs(date).date() }
                                </div>
                            );
                    }}
                    value={this.props.date}
                />
            </div>
        );
    }
}

AvailibilityCalendar.defaultProps = {
    relation : null,
    onChange : date => console.log(date)
};

export default AvailibilityCalendar;
